<template>
  <div>
    <vx-card class="campaigns" :noShadow="true">
      <h2 class="mb-8 mt-2">Campaign Insights</h2>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
          <speakol-analytics-card
            :title="(statistics.all_campaigns || 0) | addComma"
            subTitle="All Campaigns"
            icon="speakol-horn"
            backgroundColor="#DFF2FA"
            color="#0092D7"
            class="mb-4 lg:mb-0 mb-4"
            tooltip="This indicates the total number of all campaigns."
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
          <speakol-analytics-card
            :title="(statistics.active || 0) | addComma"
            :subTitle="$t('Active Campaigns')"
            icon="speakol-active"
            backgroundColor="rgba(52, 181, 118, 0.12)"
            color="#34B576"
            class="mb-4 lg:mb-0 mb-4"
            tooltip="This indicates the total number of campaigns which are able to deliver."
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
          <speakol-analytics-card
            :title="(statistics.delivering || 0) | addComma"
            :subTitle="$t('Delivering')"
            icon="speakol-active"
            backgroundColor="rgba(52, 181, 118, 0.12)"
            color="#34B576"
            class="mb-4 lg:mb-0 mb-4"
            tooltip="This indicates the total number of delivering campaigns."
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
          <speakol-analytics-card
            :title="(statistics.in_active || 0) | addComma"
            :subTitle="$t('Inactive')"
            icon="speakol-active"
            backgroundColor="rgba(216, 0, 39, 0.12)"
            color="#D80027"
            class="mb-4 lg:mb-0 mb-4"
            tooltip="This indicates the total number of in active campaigns."
          />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
  props: {
    is_admin: {
      type: Number,
      required: true
    }
  },
  components: {
    StatisticsCardLine
  },
  data () {
    return {
      statistics: {
        all_campaigns: 0,
        under_review: 0,
        hold: 0,
        accepted: 0,
        active: 0,
        completed: 0,
        scheduled: 0,
        rejected: 0,
        paused: 0
      },
      filterDates: {
        startDate: new Date('January 1, 2016'),
        endDate: new Date()
      }
    }
  },
  created () {
    this.fetchInsights()

    this.$root.$on('update-insights-cards', () => {
      this.fetchInsights()
    })
  },
  beforeDestroy () {
    this.$root.$off('update-insights-cards')
  },
  methods: {
    async fetchInsights () {

      const response = await window.axios.get('/campaigns/get-account-insights', {
        params: {
          is_admin: this.is_admin
        }
      })

      this.statistics = response.data.payload
    }
  }
}
</script>

<style lang="scss">
  .campaigns {
    .speakol-table-filter-button {
      width: 135px;
    }

    .whitespace-no-wrap {
      color: rgba(0, 0, 0, 0.5);
      font-size: 12px;
    }

    .vs-icon {
      color: rgba(0, 0, 0, 0.25);
    }

    .campaign-insights-mobile-version {
      display: none;
    }

    @media (max-width: 768px) {
      .campaign-insights-mobile-version {
        display: block;
      }

      .campaign-insights-desktop-version {
        display: none;
      }

      .campaign-insights-button-parent {
        button {
          width: 100%;
        }
      }

      .vx-card__actions {
        width: 100%;
      }

      .dropdown-menu[data-v-267f4ee2] {
        max-width: 100% !important;
        overflow-x: auto !important;
      }
    }
  }
</style>
